import { t } from '../i18n';
// client/admin-client/src/pages/Unauthorized.jsx
import React from 'react';
export default function Unauthorized() {
    return (<div className="flex flex-col items-center justify-center h-screen bg-gray-50">
      <h1 className="text-3xl font-bold mb-4">{t("\u26A0\uFE0F \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4")}</h1>
      <p className="text-gray-600">{t("\uC774 \uD398\uC774\uC9C0\uC5D0 \uC811\uADFC\uD560 \uC218 \uC788\uB294 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.")}</p>
    </div>);
}
